import React from 'react';
import styles from './Button.module.scss';
import { ButtonBase } from './ButtonBase.tsx';
export { BUTTON_SIZES } from './ButtonBase.tsx';
export const BUTTON_VARIANTS = [
    'primary',
    'cta',
    'secondary',
    'ghost',
    'danger'
];
const VARIANT_BACKGROUNDS = {
    primary: styles.primaryBackground,
    cta: styles.ctaBackground,
    secondary: styles.secondaryBackground,
    ghost: styles.ghostBackground,
    danger: styles.dangerBackground
};
export const Button = ({ variant, ...rest })=>/*#__PURE__*/ React.createElement(ButtonBase, {
        backgroundColor: VARIANT_BACKGROUNDS[variant],
        textColor: styles.textColor,
        ...rest
    });
